import React, { Children } from 'react';
import { components } from 'react-select';
import { FixedSizeList } from 'react-window';

function VirtualSelectMenuList(props) {
  const items = Children.toArray(props.children);
  const itemHeight = props.selectProps.optionHeight ?? 36;

  if (!items.length || items.some(item => !item.props?.data)) {
    return <components.MenuList {...props} />;
  }

  return (
    <FixedSizeList
      height={Math.min(props.maxHeight, items.length * itemHeight)}
      itemCount={items.length}
      itemSize={itemHeight}
      width='100%'
      outerRef={props.innerRef}
    >
      {({ index, style }) => (
        <div style={style}>{items[index]}</div>
      )}
    </FixedSizeList>
  );
}

export default VirtualSelectMenuList;
